import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import styles from './styles.css'
import { MdArrowForward } from 'react-icons/md'
import LoadingText from 'App/components/LoadingText'

const DomainCheck = ({ children }) => {
  const location = useLocation()

  useEffect(() => {
    if (!window.location.href.includes('orionx.io')) return
    setTimeout(() => {
      window.location.replace(window.location.href.replace('orionx.io', 'orionx.com'))
    }, 2000)
  }, [location])

  if (!window.location.href.includes('orionx.io')) return children
  return (
    <div className={styles.container} style={{ minHeight: window.innerHeight }}>
      <div>
        <div className={styles.logo}>
          <img src="/logo.svg" alt="Logo" />
        </div>
        <div className={styles.domains}>
          <span>.io</span>
          <MdArrowForward />
          <span>.com</span>
        </div>
        <div className={styles.title}>Ahora somos orionx.com</div>
        <LoadingText text="Te estamos redireccionando" />
      </div>
    </div>
  )
}

DomainCheck.propTypes = {
  children: PropTypes.node,
}

export default DomainCheck
